export default "__VITE_ASSET__WoYO6Uuc__"